import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertTriangle } from 'lucide-react';
export function ProblemAgitation() {
  return <section className="bg-white py-20 px-6 md:px-12 lg:px-24" data-id="element-142">
      <div className="max-w-3xl mx-auto" data-id="element-143">
        <FadeIn data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-text-black mb-10" data-id="element-145">
            La verdad incómoda que nadie te dice
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-146">
          <div className="space-y-6 text-lg md:text-xl text-text-gray leading-relaxed mb-10" data-id="element-147">
            <p data-id="element-148">
              El dolor articular crónico no es inevitable. No es simplemente "la
              edad". Y definitivamente no se resuelve tomando más pastillas.
            </p>
            <p data-id="element-149">
              Hay algo que está pasando dentro de tu cuerpo que la radiografía
              no puede mostrar. Algo que los análisis de sangre estándar no
              detectan. Un proceso silencioso que comenzó hace años en un lugar
              que jamás asociarías con el dolor de rodillas:
            </p>
            <p className="text-2xl md:text-3xl font-serif font-bold text-text-black text-center py-4" data-id="element-150">
              Tu intestino.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-151">
          <div className="bg-alert-red border-l-4 border-red-500 p-6 md:p-8 rounded-r-xl mb-10 flex gap-4 items-start" data-id="element-152">
            <AlertTriangle className="text-red-600 flex-shrink-0 mt-1" size={32} data-id="element-153" />
            <p className="text-lg md:text-xl text-text-black font-medium" data-id="element-154">
              Cada vez que tomas ibuprofeno para el dolor articular, estás
              dañando la misma barrera intestinal que está causando ese dolor.
              Es un círculo vicioso que puede durar décadas.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-155">
          <div className="space-y-6 text-lg md:text-xl text-text-gray leading-relaxed" data-id="element-156">
            <p data-id="element-157">
              Mientras tanto la industria de los suplementos te vende
              glucosamina a $60 dólares el frasco, colágeno hidrolizado a $80
              dólares el mes y cremas articulares que no penetran el espacio
              sinovial donde realmente está el problema.
            </p>
            <p className="font-medium text-text-black" data-id="element-158">
              No porque sean malos productos. Sino porque atacan el síntoma sin
              tocar la causa.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}